import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import UserContext from '../tools/contextLib';
import 'bootstrap/dist/css/bootstrap.min.css';
import { browserName, browserVersion } from 'react-device-detect';
import axios from 'axios';
import { Button, Form, FormGroup, FormText, Input, Label, Table } from 'reactstrap';
import moment from 'moment';


export class Admin extends Component {
    static displayName = Admin.name;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            returnable: [],
            browser: `${browserName}${browserVersion}`,
            ip: "",
            globalLevel: "",
            permissionFlag: true,
            //webpageDepartments: [".", ","],
            webpageDepartments: [],
            pageList: [],
            //pageList: [".", ","],
            //departments: [".", ","],
            departments: [],
            successFlag: false,
            deleteFlag: false,
            unassignWPD: [],
            bearerVAR: "Bearer " + localStorage.getItem("webApiAccessToken")
            //unassignWPD: [",","."]
        }
        this.getData();
    }

    async getData() {
        const response = await fetch('https://api.ipify.org?format=json', { dataType: 'jsonp' });
        const data = await response.json();
        this.setState({
            ip: data.ip
        })
        this.getUserInfo();
    }

    async getUserInfo() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        const response = await fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            returnable: data,
            loading: false,
            username: data.username,
        });
        this.setState({
            level: this.props.ourLevel
        });
        //var dept = this.state.returnable.level
        //dept = dept.substring(0, (dept.indexOf('-') - 1));
        this.recordComingHere();
        this.testPermission();
    }

    async recordComingHere() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            pagePK: "3",
            department: this.state.returnable.level,
            userPCID: this.state.returnable.pcid,
            ip: this.state.ip,
            browser: this.state.browser,
            userID: this.state.returnable.username
        }
        const response = await fetch('logging', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.getWebpageDepartments();
        this.getUnassignedWPD();
    }

    async testPermission() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.state.returnable.level,
            pagepk: "3"
        }
        const response = await fetch('ValidDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            permissionFlag: data
        })
    }

    async getWebpageDepartments() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.state.returnable.level
        }
        const response = await fetch('ActiveWPD', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            webpageDepartments: data
        })
        this.getAllPages();
        this.getAllDepartments();
    }

    async getUnassignedWPD() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.state.returnable.level
        }
        const response = await fetch('UnassignWPD', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            unassignWPD: data
        })
    }

    async getAllPages() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.state.returnable.level
        }
        const response = await fetch('AllPages', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            pageList: data
        })
    }

    async getAllDepartments() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.state.returnable.level
        }
        const response = await fetch('AllDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            departments: data
        })
    }

    componentDidMount() {

    }

    async newWPD(e) {
        e.preventDefault();
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        const dataInput = new FormData(e.target);
        let toSend = {
            userLevel: this.state.returnable.level,
            pagepk: dataInput.get('page'),
            deptpk: dataInput.get('department')
        }
        const response = await fetch('AddWPD', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            successFlag: data
        })
        this.getWebpageDepartments();
    }

    async deletePermission(webpage, departments) {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.state.returnable.level,
            page: webpage,
            dept: departments
        }
        const response = await fetch('DeleteWPD', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            deleteFlag: data
        })
        this.getWebpageDepartments();
    }

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
        if (this.props.justSwitch == true) {
            this.props.passNewPage(1);
        }
            return (
                <UserContext.Consumer>
                    {contextData => (
                        <div>
                            <Form className="d-flex" onSubmit={this.newWPD.bind(this)}>
                                <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                                    <Label className="mr-sm-2">Page</Label>
                                    <Input type="select" name="page" id="page">
                                        {this.state.pageList.map(pages => (
                                            <option value={pages.pk}>{pages.pagename}</option>
                                            ))}
                                    </Input>
                                </FormGroup>
                                <FormGroup>
                                    <Label className="mr-sm-2">Department</Label>
                                    <Input type="select" name="department" id="department">
                                        {this.state.departments.map(depts => (
                                            <option value={depts.pk}>{depts.departmentname}</option>
                                        ))}</Input>
                                </FormGroup>
                                <Button type="submit">Submit</Button>
                            </Form>
                            <Table striped>
                                <thead>
                                    <tr>
                                        <th className="w-30">Page</th>
                                        <th className="w-30">Department</th>
                                        <th className="w-30">Display Order</th>
                                        <th className="w-10"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.webpageDepartments.map(wpd => (
                                        <tr>
                                            <td className="w-30">{wpd.webpage}</td>
                                            <td className="w-30">{wpd.departments}</td>
                                            <td className="w-30">{wpd.sortorder}</td>
                                            <td className="w-10"><Button outline color="danger" size="sm" onClick={() => this.deletePermission(wpd.webpagepk, wpd.departmentpk)}>Delete</Button></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                            <br />
                            <br />
                            <h3>Unassigned Pages</h3>
                            <Table striped hover>
                                <thead>
                                    <tr>
                                        <th>Page PK</th>
                                        <th>Page URL</th>
                                        <th>Page Name</th>
                                        <th>Only Applications?</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.unassignWPD.map(unassign => (
                                        <tr>
                                            <td>{unassign.pagepk}</td>
                                            <td>{unassign.pageurl}</td>
                                            <td>{unassign.pagename}</td>
                                            <td>{unassign.isapps}</td>
                                        </tr>
                                        ))}
                                </tbody>
                            </Table>
                        </div>
                    )}
                </UserContext.Consumer>
            );
    }
}